import type { FunctionComponent } from 'react';

import { Tag } from '@kanda-libs/ks-design-library';
import { Title } from '@kanda-libs/ks-design-library-new';

import usePartnerReferrals from './usePartnerReferrals';

const PartnerReferrals: FunctionComponent = function () {
  const { referrals, stats } = usePartnerReferrals();

  return (
    <div>
      <Title>Stats</Title>
      <div className="mb-8 max-w-50">
        <div className="flex flex-row justify-between">
          <div>Signups:</div>
          {stats?.signups || 0}
        </div>
        <div className="flex flex-row justify-between">
          <div>Subscribers:</div>
          {stats?.subscribers || 0}
        </div>
        <div className="flex flex-row justify-between">
          <div>Activations:</div>
          {stats?.activations || 0}
        </div>
        <div className="flex flex-row justify-between">
          <div>Total verifications:</div>
          {stats?.total_referrals || 0}
        </div>
      </div>

      <Title>Referrals</Title>
      <table className="w-full">
        <thead>
          <tr className="text-neutral-700">
            <th className="text-left text-14-22">Trading Name</th>
            <th className="text-left text-14-22">Email</th>
            <th className="text-left text-14-22">Lifecycle</th>
            <th className="text-left text-14-22">Billing Status</th>
          </tr>
        </thead>
        <tbody>
          {referrals.map((referral) => (
            <tr key={`partner-referral-${referral.trading_name}`}>
              <td className="min-w-50 text-14-22-em">
                {referral.trading_name || '-'}
              </td>
              <td className="min-w-100">{referral.email}</td>
              <td className="min-w-50">
                {referral.lifecycle && (
                  <Tag
                    label={referral.lifecycle}
                    color={referral.lifecycle === 'verified' ? 'green' : 'grey'}
                    variant="solid"
                  />
                )}
              </td>
              <td>
                {referral.billing && (
                  <Tag
                    label={referral.billing}
                    color={referral.billing === 'subscribed' ? 'green' : 'grey'}
                    variant="solid"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PartnerReferrals;
